import React, { useState, useEffect } from 'react';
import { Input, Button, Card, CardBody } from 'reactstrap';
import styles from '../../../../../../assets/css/rstyling.module.css'
import ArrowLeft from '../../../../../../assets/images/arrow_left.png';
import InpersonForumICon from '../../../../../../assets/images/inperson_forum_icon.png'
import { useNavigate, useParams, useLocation } from 'react-router';
import PageHeader from '../../../../../../assets/components/pageheader/PageHeader';
import { getActivity, getActivityImg } from '../../../../../../actions/activities_actions';
import Swal from 'sweetalert'
import { useDispatch } from 'react-redux';
import ResizeDetector from 'react-resize-detector';
import Loader from "react-loaders";
import LoadingOverlay from 'react-loading-overlay-ts';

const InpersonForumPreview = (props) => {

    const location = useLocation();
    const history = useNavigate()
    const params = useParams()
    const dispatch = useDispatch()
    const [isLoading, setLoading] = useState(true)
    const [forumDetails, setForumDetails] = useState({})
    const [bannerImg, setBannerImg] = useState({})
    useEffect(() => {
        dispatch(getActivityImg(params.forumid))
        .then((response) =>{
            try{
         
            setBannerImg(response.payload.content.fileData)}catch(err){console.log('img not available')}
            
        })
        if (params.forumid !== 'undefined') {
            dispatch(getActivity(params.forumid))
                .then((response) => {
                    setForumDetails(response.payload.content)
                    setLoading(false)
                })
                .catch(err => {
                    Swal({
                        title: err.response ? err.response.data.name : "Error",
                        text: err.response ? err.response.data.content : "Please try again",
                        icon: 'error'
                    })
                })
        } else {
            setLoading(false)

        }

    }, [])

    const [currentWidth, setWidth] = useState()
    return (
        <ResizeDetector
            handleWidth
            render={({ width }) => (
                <LoadingOverlay tag="div" active={isLoading}
                    styles={{
                        overlay: (base) => ({
                            ...base,
                            background: "#fff",
                            opacity: 0.5,
                            // top: '50%'
                        }),
                    }}
                    spinner={
                        <Loader color="#6c757d" active type="ball-pulse" />
                    }>
                    <>
                        <div className="project_header">
                            <PageHeader
                                heading="Focus Group Discussion" img={InpersonForumICon}
                                btnGroup={true}
                                btn1Click={() => setWidth(1026)}
                                btn2Click={() => setWidth(470)}
                                btn3Click={() => setWidth(400)}
                            />
                        </div>

                        {/* Back Icon */}
                        <span onClick={() => location.state && location.state.from === 'create' ?
                            history(`/researcher/project/edit-inpersonforum/${params.projectid}/${params.forumid}`) :
                            history(-1)} style={{ cursor: 'pointer' }}>
                            <img src={ArrowLeft} alt="" width="8px" />
                            <label className="ml-2" style={{ cursor: 'pointer' }}>Back</label>
                        </span>

                        <div className="container-fluid" style={{ width: currentWidth }}>
                            <div style={{ fontWeight: 'bold', fontSize: "1rem" }} className="text-muted mx-3">{forumDetails.name}</div>

                            {/* Image Display */}
                            {
                                forumDetails.bannerImage &&
                                <div className="mx-3 mb-4">
                                    <div className="pt-3">
                                        <div className="position-relative">
                                            <img src={forumDetails.bannerImage} className={`img-fluid border ${styles.banner_image}`} alt="banner-image" width={200} />
                                        </div>
                                    </div>
                                </div>
                            }


                            <Card className="main-card mx-3 mt-3 mb-4">
                                <CardBody>
                                    <h6 style={{ color: '#666', fontSize: "1rem", fontWeight: '500', whiteSpace: 'pre-wrap' }}>Description</h6>
                                    {forumDetails.description}
                                </CardBody>
                            </Card>

                            <div className="row mx-2">


                                <div className="col-sm-6 col-12">
                                    <div className={styles.heading_light}>Duration (Days):</div>
                                    <div className={styles.text_bold}>{forumDetails.days}</div>
                                </div>
                                <div className="col-sm-6 col-12">
                                    <div className={styles.heading_light}>Duration Per Day (Minutes)</div>
                                    <div className={styles.text_bold}>{forumDetails.duration}</div>
                                </div>
                                <div className="col-sm-6 col-12">
                                    <div className={styles.heading_light}>Priority:</div>
                                    <div className={styles.text_bold}>{forumDetails.priority}</div>
                                </div>

                                <div className="col-sm-6 col-12">
                                    <div className={styles.heading_light}>Start date:</div>
                                    <div className={styles.text_bold}>{new Date(forumDetails.startDate).toLocaleDateString()}</div>
                                </div>

                                <div className="col-sm-6 col-12">
                                    <div className={styles.heading_light}>Audience:</div>
                                    <div className={styles.text_bold}>{forumDetails.audience && forumDetails.audience.title}</div>
                                </div>
                            </div>

                            <div className="row mt-5 mx-2">
                                <div className="col-12">
                                    <div style={{ fontWeight: 'bold', fontSize: "1rem" }}>Interview Meeting Address</div>
                                    <div className="mb-2">Check Location on Google Maps</div>
                                    <div className="d-flex m-0">
                                        <div className="col-md-10 col-8 p-0">
                                            <input className="form-control" type="text" disabled value={forumDetails.location} />

                                        </div>
                                        <div className="col-md-2 col-5">
                                            <Button className={`btn ${styles.gradient_grbl}`}>Check Location</Button>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </>
                </LoadingOverlay>


            )}
        />
    )


}

export default InpersonForumPreview


